// for card
import { MessageBox, Message } from "element-ui";
import { requestReuploadOrder } from "@/services/fulfillment-api";
export default {
  data() {
    return {
      allChecked: false,
      allExpanded: false,
      cards: [],
      editingRow: {}
    };
  },
  computed: {
    // 选中的order的Ids
    selectedIds() {
      return this.selectedItems.map(v => Number(v.order_base_info_id));
    },
    // 选中的Order
    selectedItems() {
      return this.cards.filter(v => v.checked) || [];
    }
  },
  methods: {
    // 展开所有
    expandAll() {
      this.allExpanded = !this.allExpanded;
      this.cards.forEach(v => (v.expand = this.allExpanded));
    },
    // 全选
    selectAll() {
      this.cards.forEach(v => (v.checked = this.allChecked));
    },
    // 展开units
    expandUnit(card) {
      card.expand = !card.expand;
    },
    // 显示历史记录弹窗
    showHistoryListDialog(row) {
      this.editingRow = row;
      this.$refs.historyList.visible = true;
    },
    // 包含逆向流
    containReverse(booking) {
      let units = booking.order_unit_file || [];
      if (!units.length) {
        return false;
      }
      let reverseUnits = units.filter(v => v.reverse === 1) || [];
      if (reverseUnits.length) {
        return true;
      }
      return false;
    },
    // 所有都是逆向流
    allIsReverse(booking) {
      let units = booking.order_unit_file || [];
      if (!units.length) {
        return false;
      }
      return !units.map(v => v.reverse).includes(0);
    },
    // 请求重新上传凭证
    async requestReupload(card) {
      await MessageBox.confirm(this.$t("ffm_confirm_request_reupload"), "Alert", {
        type: "info"
      });
      // 代表统计中的print
      try {
        await requestReuploadOrder({ order_base_id: card.order_base_info_id });
        this.search();
        Message(this.$t("ffm_operation_successful"));
      } catch (err) {
        Message(this.$t("ffm_operation_failed"));
      }
    }
  }
};
